'use strict'

const { f } = require("el-table-horizontal-scroll/dist/el-table-horizontal-scroll.common");
//净费支付处理
exports.setmultipleSelection = (multipleSelection) => {
    // 判断当前订单处理id是否存在
    let reval = [];
    if (multipleSelection != undefined) {
        let total_money = 0;
        let orderIDs = [];
        for (var i in multipleSelection) {
            if (multipleSelection[i].status != 6) {
                //this.$message.error('请选择未支付的订单');
                reval['message'] = '请选择已核保未支付的订单';
                return reval
                //location.reload();
            }
            //scope.row.esign_template && scope.row.esign_file && scope.row.esign_file.signFlowStatus==2
            if ((multipleSelection[i].esign_template && !multipleSelection[i].esign_file) || (multipleSelection[i].esign_template && multipleSelection[i].esign_file && multipleSelection[i].esign_file.signFlowStatus != 2)) {
                //this.$message.error('请选择先去签单');
                //return false
                reval['message'] = '请先联系内勤生成投保单合同';
                return reval
            }
            total_money += parseFloat(multipleSelection[i].sell_price);
            orderIDs.push(multipleSelection[i].order_id);
        }
        //this.multipleSelectionM.total_money = total_money;
        //this.multipleSelectionM.orderIDs = orderIDs;
        reval['total_money'] = total_money;
        reval['orderIDs'] = orderIDs;
        return reval;
    } else {
        //this.$message.error('请先选择要处理的订单');
        //return false
        reval['message'] = '请先选择要处理的订单';
        console.log('mul', reval);
        return reval
    }
}

//对公支付数据处理
exports.setPuliceInfo = (row) => {
    // 判断当前订单处理id是否存在
    let reval = [];
    if (row != undefined) {
        let total_money = 0;
        let orderIDs = [];
        for (var i in row.data) {
            total_money += parseFloat(row.data[i].sell_price);
            orderIDs.push(row.data[i].order_id);
        }
        reval['total_money'] = total_money;
        reval['orderIDs'] = orderIDs;
        return reval;
    } else {
        //this.$message.error('请先选择要处理的订单');
        //return false
        reval['message'] = '请先选择要处理的订单';
        return reval
    }
}


function areObjectsPropsEqual(arr, prop) {
    return arr.every((obj, index, self) =>
        index === 0 || obj[prop] === self[index - 1][prop]
    );
}
//对公付款扫码
exports.setScan = (multipleSelection) => {
    // 判断当前订单处理id是否存在
    let reval = [];
    if (multipleSelection != undefined) {
        let total_money = 0;
        let orderIDs = [];
        if (multipleSelection.length > 1) {
            if (areObjectsPropsEqual(multipleSelection, 'shop_id ') == areObjectsPropsEqual(multipleSelection, 'corp_channel_id')) {
                reval['message'] = '仅支持中路 同渠道同投保人不同车辆';
                return reval
            }
        }
        for (var i in multipleSelection) {
            if (multipleSelection[i].status != 6) {
                //this.$message.error('请选择未支付的订单');
                reval['message'] = '请选择已核保未支付的订单';
                return reval
            }
            total_money += parseFloat(multipleSelection[i].real_price);
            orderIDs.push(multipleSelection[i].order_id);

        }
        reval['total_money'] = total_money;
        reval['orderIDs'] = orderIDs;
        return reval;
    } else {
        //this.$message.error('请先选择要处理的订单');
        //return false
        reval['message'] = '请先选择要处理的订单';
        console.log('mul', reval);
        return reval
    }
}






// WEBPACK FOOTER //
// ./src/utils/utils/config.js